// extracted by css-extract-rspack-plugin
export default {"container":"_efb60a91","closed":"_3bc374a4","congratulationsContainer":"_a5f49464","bold":"_b57e55b3","price":"_4e2dbd5b","purchase":"_54a9ae1d"};